/** Onder deze brutomarge (% zonder btw) blijft er van een losse, gratis verzonden bestelling weinig over. */
export const LOW_MARGIN_PERCENT = 30;

/**
 * Een brutomarge als korte tekst ("41%"), in clay als hij laag is. `null` = geen inkoopprijs.
 * De betekenis staat altijd in tekst, nooit alleen in kleur.
 */
export function MarginBadge({
  percent,
  className = ''
}: {
  percent: number | null;
  className?: string;
}) {
  if (percent === null) return <span className={`text-[12px] text-muted ${className}`} data-id="element-2878" data-mp="3e9vbzbece3jo">geen inkoop</span>;
  const low = percent < LOW_MARGIN_PERCENT;
  return <span className={`tabular-nums ${low ? 'text-clay' : 'text-ink'} ${className}`} data-id="element-2879" data-mp="3i81e2648juy9">
      {Math.round(percent)}%{low && <span className="sr-only" data-id="element-2880" data-mp="399h1znt6kjj0"> (laag)</span>}
    </span>;
}